import script from "./VfmHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./VfmHeader.vue?vue&type=script&setup=true&lang=js"

import "./VfmHeader.vue?vue&type=style&index=0&id=98082cbe&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-98082cbe"]])

export default __exports__